import React, { useEffect } from "react";
import { Box, Button, Text } from "@chakra-ui/react";
import { PasswordInput } from "../custom/PasswordInput";
import Form from '../custom/Form'
import Logo from '../../components/brand/Logo'
import { UseFormReturnType } from "@mantine/form";
import { PasswordType } from "../../pages/auth/forgot_password";

const style = {
  backgroundColor: '#313338',
  width: '100%',
  borderRadius: 15,
  paddingTop: 35,
  paddingLeft: 20,
  paddingRight: 20,
  paddingBottom: 90,
  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
}

interface Props {
  handleResetPassword: (values: PasswordType) => void;
  resetPasswordForm: UseFormReturnType<{
    password: string;
  }>,
  isLoading: {
    forgotPassword: boolean;
    resetPassword: boolean;
    otp: boolean;
    resendOtp: boolean;
  }
}

const ResetPasswordForm: React.FC<Props> = ({ 
  handleResetPassword, 
  resetPasswordForm, 
  isLoading 
}) => {
  useEffect(() => {
    document.title = "Reset Password";
  }, []);

  return (
    <Form
      style={style}
      onSubmit={resetPasswordForm.onSubmit((values) => handleResetPassword(values))}
    >
      <Box w="100%" px={[3, 10]}>
        <Box
          textAlign='center'
          fontWeight='bold'
          fontSize={['xl']}
        >
          <Logo color='#B5BAC1' />

          <Text color='#B5BAC1' mt={8}>
            Reset Password
          </Text>
        </Box>

        <Box mt={5} w="100%">
          <Box mt={5}>
            <Text fontWeight='semibold' color='#B5BAC1'>
              Password
            </Text>

            <PasswordInput
              disabled={isLoading.resetPassword}
              border={resetPasswordForm.errors.password ? '2px' : '0px'}
              borderColor={resetPasswordForm.errors.password ? 'red.500' : 'transparent'}
              focusBorderColor={resetPasswordForm.errors.password ? 'red.500' : 'transparent'}
              props={{ ...resetPasswordForm.getInputProps('password') }}
            />

            {resetPasswordForm.errors.password &&
              <Text fontWeight='semibold' mt={1} color='red.500'>
                {resetPasswordForm.errors.password}
              </Text>
            }
          </Box>

          <Box mt={5}>
            <Button
              isLoading={isLoading.resetPassword}
              type="submit"
              bg='#37A75B' size="lg"
              w='100%' color='white'
              _hover={{ backgroundColor: isLoading ? '#37A75B' : '#046425' }}
            >
              Reset 
            </Button>
          </Box>
        </Box>
      </Box>
    </Form>
  )
}

export default ResetPasswordForm